import { getChildState, getParentState } from "@checkout/helpers";
import type { FlightContext } from "@checkout/states";
import type { State } from "xstate";

type SeatStateType = State<FlightContext>;

export const getIsBagsAndSeatsSelectionLoading = (state: SeatStateType) => {
  const parentState = getParentState(state.value);
  const childState = getChildState(state.value);

  return parentState === "bagsAndSeats" && childState === "bagsAndSeatsLoading";
};
